'use client';

import { useEffect, useState } from 'react';

/**
 * Returns the browser's settled visible height. iOS Safari can resolve CSS
 * viewport units against a different viewport while its toolbar is moving,
 * so mirror the proven react-div-100vh approach used by AppMana.
 */
export function useViewportHeight(): number | null {
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    let frame = 0;
    const measure = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        // The one-pixel inset prevents Safari from treating an exact-height
        // app surface as a scrollable document during toolbar transitions.
        setHeight(Math.max(0, window.innerHeight - 1));
      });
    };

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', measure);
    window.visualViewport?.addEventListener('resize', measure);

    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', measure);
      window.removeEventListener('orientationchange', measure);
      window.visualViewport?.removeEventListener('resize', measure);
    };
  }, []);

  return height;
}
